/* eslint-disable */
import React from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { Metadata } from '@thd-olt-component-react/metadata';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';

export const PEPPageContainer = ({ children }) => {
  const store = useStore();
  const { isCustomerIdentified = false } = useThdCustomer() || {};
  const { storeId, storeZip, isLocalized } = store;
  
  const defaultVariables = {
    storeId,
    zipCode: storeZip,
    skipInstallServices: false,
    skipSpecificationGroup: false,
    isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false
  };

  const merge = {
    productClientOnlyProduct: {
      queries: ['product', 'clientOnlyProduct'],
      fn: ({ query, mounted }) => 
        mounted && (query === 'product' || query === 'clientOnlyProduct') 
          ? 'productClientOnlyProduct'
          : query
    }
  }

  return (
    <Metadata>
      <QueryProvider cacheKey="page" defaultVariables={defaultVariables} fusion merge={merge}>
        {children}
      </QueryProvider>
    </Metadata>
  )
}

PEPPageContainer.propTypes = {};

PEPPageContainer.displayName = 'PEPPageContainer';

PEPPageContainer.defaultProps = {};